import React, { useState, useEffect, useMemo } from "react";
import Header from "../../../layout/Header";
import { getDynamicdata, getQRCodeAllDataByQRTemplateCode } from "../../../../services/services";
import { getColumns } from "./column";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import ExcelJS from "exceljs";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { decrypt } from "../../../../utils/encodingdecoding";
import { starblazeMerchantId } from "../../../../utils";
import { getDisplayDate } from "../../../../utils/helper";
import Paginated from "../../../partial/Paginated";

const Logs = () => {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(true);
    const COLUMNS = useMemo(() => getColumns(), []);
    const Id = localStorage.getItem("Id");

    useEffect(() => {
        const fetch = async () => {
            try {
                setLoader(true);

                const token = JSON.parse(
                    localStorage.getItem("token_gen")
                );

                const response = await getDynamicdata(
                    token?.access_token,
                    "",
                    ""
                );

                const tempData = response?.data?.map((val, ind) => {
                    return {
                        ...val,
                        useremail: val?.requestData?.discriminatorType,
                        productdescription:
                            val?.requestData?.productName,
                        quantity: val?.requestData?.quantity,
                        value: val?.requestData?.value,
                        batchno: val?.requestData?.others?.subCategory,
                        datetime: val?.CreatedDate ? getDisplayDate(val?.CreatedDate) : "",
                        download:
                            <>
                                <Link
                                    to=""
                                    title="Download CSV"
                                    onClick={() =>
                                        handleDownload(val, "csv")
                                    }
                                    className="text-success me-3"
                                >
                                    <i className="fa-solid fa-file-csv fa-lg"></i>
                                </Link>
                                {decrypt(Id) !== starblazeMerchantId && <Link
                                    to=""
                                    title="Download ZIP"
                                    onClick={() =>
                                        handleDownload(val, "zip")
                                    }
                                    className="text-warning"
                                >
                                    <i className="fa-solid fa-file-zipper fa-lg"></i>
                                </Link>}
                            </>
                    }
                });

                setData(tempData?.reverse() || []);
            } catch (error) {
                console.log(error);
            } finally {
                setLoader(false);
            }
        };
        fetch();
    }, []);
    const generateZip = async (qrcodeData) => {
        try {
            const zip = new JSZip();

            for (const item of qrcodeData) {
                if (!item.QR_Image) continue;

                const imageBlob = await createQRImageWithText(
                    item.QR_Image,
                    item.Code
                );

                zip.file(`${item.Code}.png`, imageBlob);
            }

            const content = await zip.generateAsync({
                type: "blob",
            });

            saveAs(content, "QR_Codes.zip");
        } catch (error) {
            console.error("ZIP generation error:", error);
        }
    };

    const createQRImageWithText = (base64Image, code) => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const padding = 20;
                const textHeight = 50;

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = img.width + padding * 2;
                canvas.height =
                    img.height +
                    textHeight +
                    padding * 2;

                ctx.fillStyle = "#ffffff";
                ctx.fillRect(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                ctx.drawImage(
                    img,
                    padding,
                    padding,
                    img.width,
                    img.height
                );

                ctx.fillStyle = "#000000";
                ctx.font = "bold 30px Arial";
                ctx.textAlign = "center";

                ctx.fillText(
                    code,
                    canvas.width / 2,
                    img.height + padding + 35
                );

                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    "image/png",
                    1
                );
            };

            img.onerror = reject;
            img.src = base64Image;
        });
    };

    const handleDownload = async (val, type) => {
        try {
            setLoader(true)
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
            const response = await getQRCodeAllDataByQRTemplateCode(tokenRes.access_token, val?.requestData?.code, val?.requestData?.lot);
            if (response.message === "Success" && response?.data?.length > 0) {

                const qrcodes = response.data.map((item) => ({
                    Code: item.code,
                    Value: val?.requestData?.value,
                    Product_Id: val?.requestData?.productId,
                    Product_Description: val?.requestData?.productName,
                    Type: val?.requestData?.type,
                    QR_Code_Type: val?.requestData?.QRCodetype,
                    Issue_date: val?.requestData?.issueDate
                        ? getDisplayDate(val?.requestData?.issueDate)
                        : "",
                    Category: val?.requestData?.others?.categoryName,
                    Batch_No: val?.requestData?.others?.subCategory,
                    Variant: val?.requestData?.others?.variant,
                    QR_Image: item?.qrcode
                }));

                if (type === "csv") {
                    generateExcel(qrcodes);
                } else {
                    await generateZip(qrcodes);
                }

                swal({
                    position: "center",
                    icon: "success",
                    title: "QR code download successfully",
                    showConfirmButton: false,
                    timer: 5000,
                });
            } else {
                swal({
                    title: " Oops!",
                    text: response.message,
                    icon: "error",
                    button: "oh no!",
                    timer: 5000,
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const generateExcel = async (qrcodeData) => {
        try {
            const workbook = new ExcelJS.Workbook();

            const worksheet =
                workbook.addWorksheet("QR Code Data");

            const Id = localStorage.getItem("Id");

            const shouldShowQr = decrypt(Id) !== starblazeMerchantId;

            const hasQrCode =
                shouldShowQr &&
                qrcodeData.some(
                    (item) =>
                        item.QR_Image &&
                        item.QR_Image.startsWith("data:image")
                );

            const allKeys = Object.keys(qrcodeData[0]);

            const reorderedKeys = hasQrCode
                ? [
                    "Code",
                    "QR_Image",
                    ...allKeys.filter(
                        (key) =>
                            key !== "Code" &&
                            key !== "QR_Image"
                    ),
                ]
                : [
                    "Code",
                    ...allKeys.filter(
                        (key) =>
                            key !== "Code" &&
                            key !== "QR_Image"
                    ),
                ];

            worksheet.columns = reorderedKeys.map(
                (key) => ({
                    header: key,
                    key,
                    width: key === "QR_Image" ? 34 : 30,
                })
            );

            qrcodeData.forEach((row, index) => {
                const rowIndex = index + 2;

                const newRow = {};

                reorderedKeys.forEach((key) => {
                    if (key !== "QR_Image") {
                        newRow[key] = Array.isArray(row[key])
                            ? row[key].join(", ")
                            : row[key];
                    }
                });

                worksheet.addRow(newRow);

                if (hasQrCode) {
                    worksheet.getRow(rowIndex).height = 135;
                }

                if (
                    hasQrCode &&
                    row.QR_Image &&
                    row.QR_Image.startsWith("data:image")
                ) {
                    const imageId = workbook.addImage({
                        base64: row.QR_Image,
                        extension: "png",
                    });

                    const qrCodeColIndex =
                        reorderedKeys.indexOf("QR_Image");

                    worksheet.addImage(imageId, {
                        tl: {
                            col: qrCodeColIndex + 0.15,
                            row: rowIndex - 1,
                        },
                        ext: {
                            width: 170,
                            height: 170,
                        },
                        editAs: "oneCell",
                    });
                }
            });

            const buffer =
                await workbook.xlsx.writeBuffer();

            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(blob, "QR_Code_Data.xlsx");
        } catch (error) {
            console.error(
                "Error generating Excel:",
                error
            );
        }
    };

    return (
        <>
            <Header name={"QR Logs"} />

            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4 id="transction_list">
                                    All QR Logs
                                </h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <Paginated
                                data={data}
                                columns={COLUMNS}
                                isFilterVisible={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Logs;